<template>
    <div
        class="loader-container"
        :class="{
            small: size === 'small',
            medium: size === 'medium',
            large: size === 'large' || !size,
            no_margins: no_margins,
            'overlay-loader': !!overlay
        }"
        ref="loader"
        data-test-id="loader"
    >
        <div class="loader-inner d-flex justify-center">
            <v-icon class="loader-spinner">$vuetify.icons.spinning_loader</v-icon>
        </div>
        <div v-if="message !== false" class="d-flex justify-center">
            {{ message || (size === "small" ? "" : `${l.t("app.loading", "Loading")}...`) }}
        </div>
    </div>
</template>

<script>
  import l from '../../libs/lang';

  export default {
    props: ['size', 'message', 'no_margins', 'overlay'],
    data() {
      return {
        l,
      };
    },
    mounted() {
        if (this.$props.size === 'large' || !this.$props.size) {
            const parent_modal = this.get_parent_modal();
            if (parent_modal) {
                const modal_width = parent_modal.offsetWidth;
                const modal_height = parent_modal.offsetHeight;
                this.$refs.loader.style.marginTop = `${(modal_height - this.$refs.loader.offsetHeight - 57) / 2}px`;
                this.$refs.loader.style.marginRight = `${(modal_width - this.$refs.loader.offsetWidth - 226) / 2}px`;
            } else if (!this.$props.overlay) {
                const screen_width = document.getElementById('app').offsetWidth;
                const screen_height = window.innerHeight;
                // $headerHeight: 57px;
                // $sidebar-width: 226px;
                this.$refs.loader.classList.add('absolute-loader');
                this.$refs.loader.style.top = `${(screen_height - this.$refs.loader.offsetHeight - 57) / 2}px`;
                this.$refs.loader.style.right = `${(screen_width - this.$refs.loader.offsetWidth - 226) / 2}px`;
            }
        }
    },
    methods: {
        get_parent_modal() {
            let a = this.$refs.loader;
            while (a) {
                a = a.parentNode;
                if (
                    a
                    && a.parentNode
                    && a.parentNode.classList
                    && a.parentNode.classList.contains('v-dialog--active')
                ) {
                    return a.parentNode;
                }
            }

            return null;
        }
    },
  };
</script>

 <style scoped lang="scss">
    .loader-container.large:not(.overlay-loader) {
        margin-top:  40vh;
    }
    .loader.absolute-loader {
        margin-top:  0 !important;
        position:  absolute;
    }
    .loader-spinner {
        color:  #8C98A0 !important;
        font-size:  30px !important;
    }
    .no_margins{
         margin: 0 !important;
    }
    .overlay-loader {
        position: fixed;
        display: block;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255,255,255,0.7);
        z-index: 2;
        &.large .loader-inner {
            position: absolute;
            top: 50vh;
            left: calc(50vw + 112px);
        }
    }
</style>
